// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.network-selector {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 20px;
  background: linear-gradient(135deg, rgba(17, 69, 77, 0.04) 0%, rgba(95, 184, 165, 0.04) 100%);
  border: 1px solid var(--border-gray);
  border-radius: 12px;
  margin-bottom: 20px;
  transition: all 0.3s ease;
}

.network-selector:hover {
  box-shadow: 0 2px 8px rgba(17, 69, 77, 0.1);
}

.network-selector label {
  font-weight: 600;
  color: var(--primary-teal);
  margin: 0;
  font-size: 0.95rem;
}

.network-select {
  padding: 8px 14px;
  border: 1px solid var(--border-gray);
  border-radius: 8px;
  background: var(--bg-white);
  font-size: 0.95rem;
  color: var(--text-dark);
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
}

.network-select:focus {
  outline: none;
  border-color: var(--primary-teal);
  box-shadow: 0 0 0 3px rgba(17, 69, 77, 0.1);
}

.network-select:disabled {
  background-color: var(--border-gray);
  cursor: not-allowed;
  opacity: 0.6;
}

.network-info {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}

.network-indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  animation: pulse 2s infinite;
}

.network-indicator.devnet {
  background-color: var(--success);
}

.network-indicator.testnet {
  background-color: var(--warning);
}

.network-label {
  font-size: 0.85rem;
  color: var(--text-medium);
  font-weight: 600;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(95, 184, 165, 0.7);
  }
  70% {
    box-shadow: 0 0 0 6px rgba(95, 184, 165, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(95, 184, 165, 0);
  }
}

.network-indicator.testnet {
  animation-name: pulse-testnet;
}

@keyframes pulse-testnet {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 179, 77, 0.7);
  }
  70% {
    box-shadow: 0 0 0 6px rgba(255, 179, 77, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 179, 77, 0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/NetworkSelector.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,6FAA6F;EAC7F,oCAAoC;EACpC,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE;IACE,2CAA2C;EAC7C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE;IACE,2CAA2C;EAC7C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,yCAAyC;EAC3C;AACF","sourcesContent":[".network-selector {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 12px 20px;\n  background: linear-gradient(135deg, rgba(17, 69, 77, 0.04) 0%, rgba(95, 184, 165, 0.04) 100%);\n  border: 1px solid var(--border-gray);\n  border-radius: 12px;\n  margin-bottom: 20px;\n  transition: all 0.3s ease;\n}\n\n.network-selector:hover {\n  box-shadow: 0 2px 8px rgba(17, 69, 77, 0.1);\n}\n\n.network-selector label {\n  font-weight: 600;\n  color: var(--primary-teal);\n  margin: 0;\n  font-size: 0.95rem;\n}\n\n.network-select {\n  padding: 8px 14px;\n  border: 1px solid var(--border-gray);\n  border-radius: 8px;\n  background: var(--bg-white);\n  font-size: 0.95rem;\n  color: var(--text-dark);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-weight: 500;\n}\n\n.network-select:focus {\n  outline: none;\n  border-color: var(--primary-teal);\n  box-shadow: 0 0 0 3px rgba(17, 69, 77, 0.1);\n}\n\n.network-select:disabled {\n  background-color: var(--border-gray);\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.network-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-left: auto;\n}\n\n.network-indicator {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  animation: pulse 2s infinite;\n}\n\n.network-indicator.devnet {\n  background-color: var(--success);\n}\n\n.network-indicator.testnet {\n  background-color: var(--warning);\n}\n\n.network-label {\n  font-size: 0.85rem;\n  color: var(--text-medium);\n  font-weight: 600;\n}\n\n@keyframes pulse {\n  0% {\n    box-shadow: 0 0 0 0 rgba(95, 184, 165, 0.7);\n  }\n  70% {\n    box-shadow: 0 0 0 6px rgba(95, 184, 165, 0);\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(95, 184, 165, 0);\n  }\n}\n\n.network-indicator.testnet {\n  animation-name: pulse-testnet;\n}\n\n@keyframes pulse-testnet {\n  0% {\n    box-shadow: 0 0 0 0 rgba(255, 179, 77, 0.7);\n  }\n  70% {\n    box-shadow: 0 0 0 6px rgba(255, 179, 77, 0);\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(255, 179, 77, 0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
